module.exports = __webpack_public_path__ + "static/media/TapThinRoot1.e40dc37e.PNG";